import { render, staticRenderFns } from "./UserVerifyResendEmail.vue?vue&type=template&id=a965222a&"
import script from "./UserVerifyResendEmail.vue?vue&type=script&lang=js&"
export * from "./UserVerifyResendEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports